import {generateInternalFeeId} from "../containers/Cy/components/TieredFeeDataBox/helper";

const initialState = {
  id: null,
  html: null,
  pending: false,
  error: false,
  message: "",
  doAppUrl: null,
  portfolioIds: [],
  doSessionId: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "PORTFOLIO_GET_QUIK_FILLED_FORMS_REQUESTED":
    case "MULTI_PORTFOLIO_ONBOARD_REQUESTED":
    case "STRATEGY_CHANGE_ONBOARD_REQUESTED":
      return { ...initialState, pending: true };
    case "PORTFOLIO_GET_QUIK_FILLED_FORMS_SUCCESS":
    case "MULTI_PORTFOLIO_ONBOARD_SUCCESS":
    case "STRATEGY_CHANGE_ONBOARD_SUCCESS": {
      const payload = action.payload
      if (payload.onboardStyle && payload.onboardStyle === 'do') {
        return {
          id: payload.doSessionId,
          onboardStyle: 'do',
          html: null,
          url: null,
          pending: false,
          error: false,
          message: payload.Message || "",
          appUrl: payload.appLocation,
          portfolioIds: payload.portfolios,
          doSessionId: payload.session.id
        };
      }
      if (!payload.onboardStyle || payload.onboardStyle !== 'do') {
        return {
          id: payload.ResultData.UNID ? decodeURIComponent(action.payload.ResultData.UNID) : generateInternalFeeId(),
          onboardStyle: 'quik',
          html: payload.ResultData.HTML,
          url: null,
          pending: false,
          error: false,
          message: payload.Message || "",
          appUrl: null,
          portfolioIds: payload.portfolios,
          doSessionId: null
        };
      }

      return state;
    }
    case "PORTFOLIO_GET_QUIK_FILLED_FORMS_FAIL":
    case "MULTI_PORTFOLIO_ONBOARD_FAIL":
    case "STRATEGY_CHANGE_ONBOARD_FAIL":
      return {
        id: null,
        html: null,
        pending: false,
        error: true,
        onboardStyle: '',
        message: action.payload.Message || "",
        appUrl: null
      };
    case "PORTFOLIO_QUIK_FORM_DATA_RESET":
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/quik.reducer.js